export const SET_PRINTING = '@uhc/utility/SET_PRINTING';
